import Model    from "./Model";
import City     from "./City";
import Edition  from "./Edition";
import Sector   from "./Sector";
import Venue    from "./Venue";



export default class Event extends Model
{
    constructor( options = {} )
    {
        super(null);

        this.setOptions(options);
    }

    setOptions( options = {} )
    {
        this.id             = options.id                    || null;
        this.name           = options.name                  || null;
        this.edition_id     = options.edition_id            || null;
        this.edition        = new Edition(options.edition   || {});
        this.startAt        = options.startAt               || null;
        this.endAt          = options.endAt                 || null;
        this.start_at       = options.start_at ? new moment(options.start_at) : null;
        this.end_at         = options.end_at   ? new moment(options.end_at)   : null;
        this.sector         = new Sector(options.sector     || {});
        this.city           = new City(options.city         || {});
        this.logoUrl        = options.logoUrl               || null;
        this.venue          = new Venue(options.venue       || {});
        this.periodicity    = options.periodicity           || null;
        this.scope          = options.scope                 || null;
        this.web            = options.web                   || null;
    }

    toJson ()
    {
        return {
            id          : this.id,
            name        : this.name,
            startAt     : this.startAt,
            endAt       : this.endAt,
            edition_id  : this.edition_id,
            city        : this.city.toJson(),
            edition     : this.edition.toJson(),
            start_at    : this.start_at ? this.start_at.format("YYYY-MM-DD") : null,
            end_at      : this.end_at   ? this.end_at.format("YYYY-MM-DD")   : null,
            sector      : this.sector.toJson(),
            logoUrl     : this.logoUrl,
            venue       : this.venue.toJson(),
            periodicity : this.periodicity,
            scope       : this.scope,
            web         : this.web,
        }
    }
}



// WEBPACK FOOTER //
// ./resources/js/models/Event.js